// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TeacherHeader_wrapper__fOy4L","active":"TeacherHeader_active__2DWKr"};